export type ThemeId = 'light' | 'dark';

export interface ThemeMeta {
  /** CSS `color-scheme` šablony - řídí vzhled nativních prvků prohlížeče. */
  colorScheme: 'light' | 'dark';
  /** Hodnota <meta name="theme-color"> pro tuto šablonu. */
  themeColor: string;
}

/**
 * FR01 20261001_LandingPage/001_Theming (FR-02) - jediný zdroj hodnot `colorScheme` a `themeColor`
 * obou šablon. Aplikační šablony (`apps/web/src/theme/themes/*.ts`) je přebírají odsud, statický
 * `theme-init.js` je má kvůli běhu mimo bundler natvrdo a jejich shodu hlídá
 * `theme-init-parity.test.ts`.
 */
export const THEME_META = {
  light: { colorScheme: 'light', themeColor: '#05C88E' },
  dark: { colorScheme: 'dark', themeColor: '#0B0F14' },
} as const satisfies Record<ThemeId, ThemeMeta>;
